import React from "react";
import { Redirect, useParams } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { Shortcut } from "../../../../application/domain/ttzk-portal";
import { TtzkPortalShortcutDetailService } from "../../../../application/service/ttzk-portal/ttzk-portal-detail-service";
import { useAuthContextV2 } from "../../../../auth-state";
import { TtzkPortalR } from "../route";
import { PortalTemplate } from "../../../template/portal/default-template";
import ShortcutDetail from "../../../organisms/ttzk-portal/shortcut-detail";

type Props = {
  shortcut: Shortcut;
  fetchShortcutByID: (shortcutId: string) => Promise<void>;
  onPublish: () => void;
  onUnPublish: () => void;
};

export const ShortcutDetailPage: React.FC<Props> = ({
  shortcut,
  fetchShortcutByID,
  onPublish,
  onUnPublish,
}) => {
  const { auth } = useAuthContextV2();
  const { shortcutId } = useParams<{ shortcutId: string }>();

  if (!auth.isPortalStandardPlan()) {
    return <Redirect to={TtzkPortalR.Home.link({})} />;
  }
  return (
    <>
      {auth.hasPermissions("ttzk_portal.shortcuts.read") && (
        <PortalTemplate
          breadcrumbs={[
            { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
            {
              to: TtzkPortalR.ShortcutList.link({}),
              title: "ショートカット一覧",
            },
            {
              to: TtzkPortalR.ShortcutDetail.link({ shortcutId }),
              title: shortcut.name,
            },
          ]}
        >
          <ShortcutDetail
            shortcutId={shortcutId}
            shortcut={shortcut}
            fetchShortcutByID={fetchShortcutByID}
            onPublish={onPublish}
            onUnPublish={onUnPublish}
          />
        </PortalTemplate>
      )}
    </>
  );
};

export const ShortcutDetailContainer = connectPageService(
  ShortcutDetailPage,
  () => new TtzkPortalShortcutDetailService(),
);
